export const WEEK_CREDIT_RATE = 50e9;
